(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(slider) {
    if (slider.dataset.obSlider) return;
    slider.dataset.obSlider = '1';
    var track = slider.querySelector('.obacco-products');
    if (!track) return;
    var toggle = slider.parentElement.querySelector('.obacco-slider__toggle');
    var timer = null;
    var userPaused = REDUCED;

    function scrollable() {
      return track.scrollWidth > track.clientWidth + 4;
    }

    function cardStep() {
      var cards = track.children;
      if (cards.length > 1) return cards[1].offsetLeft - cards[0].offsetLeft;
      return track.clientWidth;
    }

    function step() {
      if (!scrollable()) return;
      var end = track.scrollWidth - track.clientWidth;
      var next = track.scrollLeft >= end - 1 ? 0 : track.scrollLeft + cardStep();
      track.scrollTo({ left: next, behavior: REDUCED ? 'auto' : 'smooth' });
    }

    function renderToggle() {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', String(userPaused));
      toggle.setAttribute('aria-label', userPaused ? 'Play autoplay' : 'Pause autoplay');
      toggle.textContent = userPaused ? '▶' : '❚❚';
    }

    function play() {
      if (timer || userPaused || !scrollable() || document.hidden) return;
      timer = setInterval(step, 3000);
    }

    function pause() {
      clearInterval(timer);
      timer = null;
    }

    if (toggle) {
      toggle.addEventListener('click', function () {
        userPaused = !userPaused;
        if (userPaused) pause();
        else play();
        renderToggle();
      });
    }
    renderToggle();

    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
      e.preventDefault();
      pause();
      var dir = e.key === 'ArrowRight' ? 1 : -1;
      track.scrollTo({ left: track.scrollLeft + dir * cardStep(), behavior: REDUCED ? 'auto' : 'smooth' });
      play();
    });

    var dragging = false;
    var startX = 0;
    var startScroll = 0;
    var moved = 0;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      dragging = false;
      moved = 0;
      startX = e.clientX;
      startScroll = track.scrollLeft;
    });

    track.addEventListener('pointermove', function (e) {
      if (startX === null) return;
      var dx = e.clientX - startX;
      if (!dragging) {
        if (Math.abs(dx) <= 6) return;
        dragging = true;
        slider.classList.add('obacco-slider--dragging');
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
        pause();
      }
      moved = Math.abs(dx);
      track.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (startX === null) return;
      startX = null;
      if (!dragging) return;
      dragging = false;
      slider.classList.remove('obacco-slider--dragging');
      play();
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener('click', function (e) {
      if (moved > 6) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);

    slider.addEventListener('mouseenter', pause);
    slider.addEventListener('mouseleave', play);
    slider.addEventListener('focusin', pause);
    slider.addEventListener('focusout', play);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) pause();
      else play();
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) play();
        else pause();
      }).observe(slider);
    }

    play();
  }

  document.querySelectorAll('.obacco-slider').forEach(setup);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.obacco-slider').forEach(setup);
  });
})();
